import { render, staticRenderFns } from "./NextbuyCashbackLocksTable.vue?vue&type=template&id=2ae2b2a0&scoped=true"
import script from "./NextbuyCashbackLocksTable.vue?vue&type=script&lang=js"
export * from "./NextbuyCashbackLocksTable.vue?vue&type=script&lang=js"
import style0 from "./NextbuyCashbackLocksTable.vue?vue&type=style&index=0&id=2ae2b2a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae2b2a0",
  null
  
)

export default component.exports